<template>
    <div class="loader-box"
         :class="{ 'local-position': local }">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="loader-text">{{ text }}</div>
    </div>
</template>

<script type="application/javascript">
export default {
    props: {
        text: {
            required: false,
            type: String,
            default: localStorage.getItem('lang') === 'en' ? 'Loading...' : 'تحميل...'
        },
        local: {
            required: false,
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">

.loader-box {
    display: flex;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    background-color: rgb(0 0 0 / 30%);
    flex-direction: column;
    z-index: 1000;
}

.loader-box.local-position {
    position: inherit;
    background-color: inherit;
    margin-top: 5rem;

    .loader-text {
        color: #7A7979FF;
    }

    .lds-ring div {
        border: 8px solid #7A7979FF;
        border-color: #7A7979FF transparent transparent transparent;
    }
}

.loader-text {
    font-weight: bolder;
    color: white;
    font-size: 1.4rem;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>
